"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MooIcon = function MooIcon(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 24 24"
  }, props), _react.default.createElement("path", {
    d: "M18.71 13.69c-.23-1.45-1.26-3.76-3.07-6.91-1-1.71-2.7-4.47-2.43-4C12.84 2.24 12.56 2 12 2a1.3 1.3 0 0 0-1.14.68v.06c.11-.18-.41.64-.75 1.17-.56.89-1.14 1.86-1.71 2.86-1.81 3.15-2.84 5.46-3.08 6.94A6.91 6.91 0 0 0 12 22a6.8 6.8 0 0 0 5.43-2.7 6.89 6.89 0 0 0 1.42-4.21 7 7 0 0 0-.14-1.4zm-2.49 4.67a5.28 5.28 0 0 1-4.22 2.1 5.29 5.29 0 0 1-4.23-2.1 5.41 5.41 0 0 1-1-4.36c.2-1.27 1.18-3.46 2.9-6.45.57-1 1.14-1.94 1.69-2.82l.64-1 .64 1c.55.88 1.12 1.83 1.68 2.81 1.68 3 2.68 5.19 2.89 6.46a5.51 5.51 0 0 1 .11 1.12 5.34 5.34 0 0 1-1.1 3.24z",
    fillRule: "evenodd"
  }));
};

MooIcon.propTypes = {
  className: _propTypes.default.string
};
var _default = MooIcon;
exports.default = _default;